import type { SessionData } from "@/types/session"

/**
 * Séance 1 — Intermédiaire Sèche & Définition — Salle
 * Cycle 1 : Full Body — Endurance de force (Sem. 2-5)
 * Format : Circuit Training Full Body — 3 rounds
 */
export const MOCK_SESSION_S1: SessionData = {
  id: "mock-s1-inter-seche",
  sessionNumber: 1,
  weekNumber: 2,
  cycleNumber: 1,
  cycleName: "Full Body — Endurance de force & déficit calorique",
  format: "circuit",
  formatLabel: "Circuit Training Full Body — 3 rounds",
  displayName: "Full Body — Circuit Training",
  totalRounds: 3,
  estimatedDuration: "60 min",
  interRoundRest: 180,
  interRoundNature: "Repos actif : Marche",

  warmup: [
    {
      label: "Mobilité Routine",
      duration: "5 min",
      exercises: [
        { name: "World's Greatest Stretch", reps: "5 /côté" },
        { name: "Squat Mobility Twist", reps: "8 /côté" },
        { name: "Rocking Frog Stretch", reps: "10" },
        { name: "PVC Overhead Squat", reps: "10" },
        { name: "Across Chest Shoulder Stretch", reps: "15 sec" },
        { name: "Cat-Cow Stretch", reps: "10" },
      ],
    },
    {
      label: "Dynamic Warm-Up",
      duration: "5 min",
      rounds: 2,
      restBetweenRounds: 60,
      exercises: [
        { name: "Air Squats", reps: "10" },
        { name: "Mountain Climbers", reps: "10" },
        { name: "Jumping Jacks", reps: "10" },
        { name: "Push-Ups", reps: "5" },
      ],
    },
  ],

  exercises: [
    {
      order: 1,
      name: "Back Squat",
      canonicalName: "Back Squat",
      category: "Polyarticulaire",
      primaryMuscle: "Quadriceps",
      secondaryMuscle: "Grand fessier",
      sets: "3",
      reps: "12",
      tempo: "X0X0",
      tempoExplain: "Exécution continue et explosive",
      charge: "30 kg",
      restBetweenSets: 0,
      restBetweenExercises: 0,
      restNature: "Active (sur place)",
      restExplain: "Enchaîner avec l'exercice suivant sans récupération",
      instructions: [
        "Pieds largeur d'épaules, pointes légèrement ouvertes",
        "Descendre cuisses parallèles au sol",
        "Dos droit, poitrine haute",
        "Pousser à travers les talons",
      ],
    },
    {
      order: 2,
      name: "DB Standing Overhead Press",
      canonicalName: "DB Standing Overhead Press",
      category: "Polyarticulaire",
      primaryMuscle: "Deltoïde antérieur",
      secondaryMuscle: "Deltoïde moyen",
      sets: "3",
      reps: "8",
      tempo: "2010",
      tempoExplain: "2 sec descente · 0 sec iso bas · 1 sec montée · 0 sec iso haut",
      charge: "14 kg",
      restBetweenSets: 0,
      restBetweenExercises: 0,
      restNature: "Active (sur place)",
      restExplain: "Enchaîner avec l'exercice suivant sans récupération",
      instructions: [
        "Haltères au niveau des épaules, paumes vers l'avant",
        "Pousser verticalement, core engagé",
        "Contrôler la descente (2 secondes)",
        "Ne pas cambrer le dos",
      ],
    },
    {
      order: 3,
      name: "Push-Up Renegade Row",
      canonicalName: "Push-Up Renegade Row",
      category: "Polyarticulaire",
      primaryMuscle: "Grand dorsal",
      secondaryMuscle: "Pectoraux",
      sets: "3",
      reps: "6 /côté",
      tempo: "2010",
      tempoExplain: "2 sec descente · 0 sec iso bas · 1 sec montée · 0 sec iso haut",
      charge: "10 kg",
      restBetweenSets: 0,
      restBetweenExercises: 0,
      restNature: "Active (sur place)",
      restExplain: "Enchaîner avec l'exercice suivant sans récupération",
      instructions: [
        "Position de pompe, mains sur haltères",
        "Pompe puis tirage haltère vers la hanche",
        "Alterner chaque côté, hanches stables",
        "Engager le core, éviter la rotation",
      ],
    },
    {
      order: 4,
      name: "Dumbbell Swing",
      canonicalName: "Dumbbell Swing",
      category: "Pliométrie",
      primaryMuscle: "Grand fessier",
      secondaryMuscle: "Épaules",
      sets: "3",
      reps: "8",
      tempo: "X0X0",
      tempoExplain: "Exécution continue et explosive",
      charge: "10 kg",
      restBetweenSets: 0,
      restBetweenExercises: 0,
      restNature: "Active (sur place)",
      restExplain: "Enchaîner avec l'exercice suivant sans récupération",
      instructions: [
        "Mouvement explosif de la hanche (hip hinge)",
        "Bras tendus, élan des hanches",
        "Contracter les fessiers au sommet",
        "Laisser l'haltère redescendre naturellement",
      ],
    },
    {
      order: 5,
      name: "Cable Face Pull",
      canonicalName: "Cable Face Pull",
      category: "Polyarticulaire",
      primaryMuscle: "Deltoïde postérieur",
      secondaryMuscle: "Rotateurs externes",
      sets: "3",
      reps: "10",
      tempo: "2010",
      tempoExplain: "2 sec descente · 0 sec iso bas · 1 sec montée · 0 sec iso haut",
      charge: "15 kg",
      restBetweenSets: 0,
      restBetweenExercises: 0,
      restNature: "Active (sur place)",
      restExplain: "Enchaîner avec l'exercice suivant sans récupération",
      instructions: [
        "Poulie haute, corde à deux poignées",
        "Tirer vers le visage, coudes ouverts",
        "Rotation externe en fin de mouvement",
        "Contrôler le retour (2 secondes)",
      ],
    },
    {
      order: 6,
      name: "Close Grip Bench Press",
      canonicalName: "Close Grip Bench Press",
      category: "Polyarticulaire",
      primaryMuscle: "Triceps",
      secondaryMuscle: "Grand pectoral",
      sets: "3",
      reps: "12",
      tempo: "2010",
      tempoExplain: "2 sec descente · 0 sec iso bas · 1 sec montée · 0 sec iso haut",
      charge: "30 kg",
      restBetweenSets: 0,
      restBetweenExercises: 0,
      restNature: "Active (sur place)",
      restExplain: "Enchaîner avec l'exercice suivant sans récupération",
      instructions: [
        "Prise serrée (largeur des épaules)",
        "Descendre la barre vers le bas des pectoraux",
        "Coudes proches du corps",
        "Descente contrôlée, poussée explosive",
      ],
    },
  ],

  finisher: [
    { label: "Wall Ball", reps: "10", charge: "8 kg" },
    { label: "Burpees", reps: "5", charge: "PDC" },
  ],

  cooldown: [
    {
      label: "Course légère sur tapis roulant",
      detail: "Vitesse = 6 km/h",
      duration: "10 min",
    },
  ],

  notes: "Finisher : 10 Wall Ball (40% 1RM) + 5 burpees + 1 km tapis à 7 km/h (5% pente)",
}
